import {
  actionCreator,
  BUSINESS_NAME_API,
  checkHttpStatus,
  FORGOT_PASSWORD_API,
  handleFirstLoginAfterSignUp,
  handleLoginRedirect,
  handleLogoutRedirect,
  handleRefreshTokenRedirect,
  handleSecurityQuestionRedirect,
  jsonApiHeader,
  jsonApiHeaderBusinessName,
  LOGIN_API,
  loginActionTypes,
  LOGOUT_API,
  UPDATE_LOGIN_PASSWORD_API,
  REFRESH_TOKEN,
  RESET_PASSWORD_API,
  CHECK_RESET_PASSWORD_LINK_IS_VALID,
  FORCED_LOGOUT_API,
} from './../constants/ApiConstants';

import { AgencyDashboardActionTypes } from './../../Dashboards/constants/ApiConstants';
import { PatientDashboardActionTypes } from './../../PatientPortal/containers/dashboard/constants/ApiConstants';

// import Alert from 'react-s-alert';
import GlobalVariables, { calculateTimeZone, filterNonISO8859OrLimitToASCII } from '../../../actions/utilAction';
import moment from 'moment';
import axios from "axios";

/**
 * @todo check business name
 * @desc get subdomain name from url and take it as business name.
 *       Check business name and return message if business name not subscribed.
 *        /VerifyBusinessName?BusinessName
 */
 export async function getIpClient(){
  try {
    const response = await axios.get('https://ipapi.co/json/');
    
    if(response && response.data)
    {
      GlobalVariables.IpAddress = response.data.ip;
    }
  } catch (error) {
    console.error(error);
  }
}


export function checkBusinessName(businessName) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.check_business_name.REQUEST));
    fetch(`${BUSINESS_NAME_API}?BusinessName=${businessName}`, {
      method: 'get',
      headers: jsonApiHeaderBusinessName(null, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response............',response)
        if (response.statusCode === 200) {
          getIpClient();
          dispatch(actionCreator(loginActionTypes.check_business_name.SUCCESS, { access_token: response.data.businessToken, businessCheckMessage: null, organizationDetails: response.data.organization }));
        }
        if (response.statusCode === 401) {
          dispatch(actionCreator(loginActionTypes.check_business_name.SUCCESS, { access_token: null, businessCheckMessage: response.message }));
        }
      }).catch(function(error) {
        console.log('error logs: ', error);
      });
  };
}

export function loginAction(authData, businessNameCheck, agencyName = 'VIP') {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_login.REQUEST));
    fetch(`${LOGIN_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
        'Timezone': filterNonISO8859OrLimitToASCII(calculateTimeZone()),//converting the non-iso string with iso/empty string'Timezone': calculateTimeZone(),
        'IPAddress': agencyName.toUpperCase() === 'DEMO' ? '' : GlobalVariables.IpAddress,
        'LocationID': GlobalVariables.CurrentLocationId ? GlobalVariables.CurrentLocationId : 0,
        'Offset': moment().utcOffset(),
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response1................',response)
        if ((response.statusCode >= 400 && response.statusCode < 500) && response.message) {
          let errorMessage = response.message;
          dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
        } else if (response.statusCode === 205) {
          let errorMessage = response.message;
          dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { response: response, errorMessage: errorMessage, currentLocationId: null, access_token: null, loginUserInfo: null, isOnlyForAgency: false,data: response.data }));
        } else {
          if (response.access_token) {
            let userPermission = response.userPermission;
            let currentLocationId = response.data.staffLocation && response.data.staffLocation.length > 0 ? response.data.staffLocation[0].locationID : null;
            GlobalVariables.CurrentLocationId = currentLocationId;
            dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data, userPermission: userPermission, appConfigurations: response.appConfigurations, isOnlyForAgency: true, userLocationList: response.userLocations,data: response.data}));
            dispatch(actionCreator(AgencyDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, { passwordExpiryStatus: response.passwordExpiryStatus }));
            handleLoginRedirect(response.access_token, '', '/dashboard');
          } else {
            if (response.firstTimeLogin && response.firstTimeLogin === true) {
              handleSecurityQuestionRedirect(response, authData);
              dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: null, access_token: null, loginUserInfo: null, isOnlyForAgency: false,data: response.data,data: response.data }));
            } else {
              handleFirstLoginAfterSignUp(response, authData);
              dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: null, access_token: null, loginUserInfo: null, isOnlyForAgency: false,data: response.data }));
            }
          }
        }
      }).catch(function(error) {
        // console.log('error logs: ', error);
        let errorMessage = 'Invalid username or password';
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
      });
  };
}

export function logoutAction() {
  return (dispatch, getState) => {
    dispatch(actionCreator(loginActionTypes.logout_user.REQUEST));
    fetch(`${LOGOUT_API}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(loginActionTypes.logout_user.SUCCESS));
        handleLogoutRedirect('/login');
      }).catch(function(error) {
        console.log(error);
        //let errorMessage = 'Oops, something went wrong, please try later';
        dispatch(actionCreator(loginActionTypes.logout_user.SUCCESS));
        handleLogoutRedirect('/login');
      });
  };
}

export function logoutOnIdleAction() {
  return (dispatch, getState) => {
    dispatch(actionCreator(loginActionTypes.forced_logout_user.REQUEST));
    fetch(`${FORCED_LOGOUT_API}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(loginActionTypes.forced_logout_user.SUCCESS));
        handleLogoutRedirect('/login');
      }).catch(function(error) {
        console.log(error);
        //let errorMessage = 'Oops, something went wrong, please try later';
        dispatch(actionCreator(loginActionTypes.forced_logout_user.SUCCESS));
        handleLogoutRedirect('/login');
      });
  };
}

export function refreshAuthToken(old_token, prevUrl) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.refresh_token.REQUEST));
    fetch(`${REFRESH_TOKEN}`, {
      method: 'get',
      headers: jsonApiHeader(old_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response................',response)
        if (response.access_token) {

          if (response.data && response.data.roleName && (response.data.roleName.toUpperCase() === 'SUPERADMIN' || response.data.roleName.toUpperCase() === 'SUPERUSER')) {
            let userPermission = response.userPermission;
            dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: null, access_token: response.access_token, loginUserInfo: response.data, userPermission: userPermission, isOnlyForAgency: false,data: response.data }));
            // handleLoginRedirect(response.access_token, '', '/webadmin/dashboard');
            if (prevUrl === '/' || prevUrl === '/webadmin') {
              handleLoginRedirect(response.access_token, '', '/webadmin/dashboard');
            } else {
              handleRefreshTokenRedirect(response.access_token, prevUrl);
            }
          } else if (response.data && response.data.users3 && response.data.users3.userRoles && response.data.users3.userRoles.roleName.toUpperCase() === 'CLIENT') {
            let currentLocationId = response.data.locationID;
            GlobalVariables.CurrentLocationId = currentLocationId;
            dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data, isOnlyForAgency: false,data: response.data }));
            dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, { passwordExpiryStatus: response.passwordExpiryStatus }));
            // handleLoginRedirect(response.access_token, '', '/dashboard');
            if (prevUrl === '/') {
              //handleLoginRedirect(response.access_token, '', '/client-dashboard');
              handleLoginRedirect(response.access_token, '', '/my-profile');
            } else {
              handleRefreshTokenRedirect(response.access_token, prevUrl);
            }
          } else {
            let userPermission = response.userPermission;
            let currentLocationId = response.data.staffLocation && response.data.staffLocation.length > 0 ? response.data.staffLocation[0].locationID : null;
            GlobalVariables.CurrentLocationId = currentLocationId;
            dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data, userPermission: userPermission, appConfigurations: response.appConfigurations, isOnlyForAgency: true, userLocationList: response.userLocations,data: response.data}));
            dispatch(actionCreator(AgencyDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, { passwordExpiryStatus: response.passwordExpiryStatus }));
            // handleLoginRedirect(response.access_token, '', '/dashboard');
            if (prevUrl === '/') {
              handleLoginRedirect(response.access_token, '', '/dashboard');
            } else {
              handleRefreshTokenRedirect(response.access_token, prevUrl);
            }
          }
        } else {
          dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: null, currentLocationId: null, access_token: null, loginUserInfo: null }));
          handleLogoutRedirect('/login');
        }
      }).catch(function(error) {
        console.log(error);
        let errorMessage = 'Oops, something went wrong, please try later';
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
        handleLogoutRedirect('/login');
      });
  };
}

export function forgotPasswordAction(authData, businessNameCheck) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_forgotPassword.REQUEST));
    fetch(`${FORGOT_PASSWORD_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
        'Timezone': filterNonISO8859OrLimitToASCII(calculateTimeZone()),//converting the non-iso string with iso/empty string
        'IPAddress': GlobalVariables.IpAddress,
        'Offset': moment().utcOffset(),
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        let message = response.message;
        if (response.statusCode >= 200 && response.statusCode < 300) {
          dispatch(actionCreator(loginActionTypes.post_forgotPassword.SUCCESS, { successMessage: message }));
        } else {
          dispatch(actionCreator(loginActionTypes.post_forgotPassword.FAILURE, { errorMessage: message }));
        }
      }).catch(function(error) {
        console.log('error forgot password....', error);
      });
  };
}

export function ResetPasswordAction(authData, businessNameCheck) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_resetPassword.REQUEST));
    fetch(`${RESET_PASSWORD_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
        'Timezone': filterNonISO8859OrLimitToASCII(calculateTimeZone()),//converting the non-iso string with iso/empty string
        'IPAddress': GlobalVariables.IpAddress,
        'Offset': moment().utcOffset(),
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        let message = response.message;
        if (response.statusCode >= 200 && response.statusCode < 300) {
          dispatch(actionCreator(loginActionTypes.post_resetPassword.SUCCESS, { successMessage: message }));
        } else {
          dispatch(actionCreator(loginActionTypes.post_resetPassword.FAILURE, { errorMessage: message }));
        }
      }).catch(function(error) {
        console.log('error reset password: ', error);
      });
  };
}

export function updateLoginUserPasswordAction(postData, businessNameCheck) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.update_loginUserPassword.REQUEST));
    fetch(`${UPDATE_LOGIN_PASSWORD_API}`, {
      method: 'PATCH',
      body: JSON.stringify(postData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          let responseObj = { response: response, successMessage: response.message, errorMessage: null };
          dispatch(actionCreator(loginActionTypes.update_loginUserPassword.SUCCESS, responseObj));
        } else {
          let responseObj = { response: response, successMessage: null, errorMessage: response.message };
          dispatch(actionCreator(loginActionTypes.update_loginUserPassword.SUCCESS, responseObj));
        }
      })
      .catch(function(error) {
        console.log(error);
        let errorMessage = 'Oops, something went wrong, please try later';
        dispatch(actionCreator(loginActionTypes.update_loginUserPassword.SUCCESS, { errorMessage: errorMessage }));
      });
  };
}

export function changeLocationAction(locationId, loginInfo, userPermission, appConfigurations, userLocations) {

  // let access_token = localStorage.getItem('access_token');
  // if (access_token != null && loginInfo == null) {
  //   let prevUrl = history.location.pathname; // @get current url and send it as previous url on page refresh using ctl + F5
  //   this.props.refreshAuthToken(access_token, prevUrl);
  // }
  return (dispatch, getState) => {
    dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: locationId, access_token: getState().login.access_token, loginUserInfo: loginInfo, userPermission: userPermission, appConfigurations: appConfigurations, isOnlyForAgency: true, userLocationList: userLocations}));
  };
}

export function getResetPasswordLinkIsValidAction(token, checkBusinessName) {
  return (dispatch, getState) => {
    dispatch(actionCreator(loginActionTypes.get_resetPasswordLinkIsValid.REQUEST));
    fetch(`${CHECK_RESET_PASSWORD_LINK_IS_VALID}`, {
      method: 'post',
      body: JSON.stringify({token}),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': checkBusinessName,
      },
    })
    .then(checkHttpStatus)
    .then((res) => {
      dispatch(actionCreator(loginActionTypes.get_resetPasswordLinkIsValid.SUCCESS, res));
    }).catch((err) => {
      console.log("error", err);
      dispatch(actionCreator(loginActionTypes.get_resetPasswordLinkIsValid.FAILURE, {}));
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/logins/actions/LoginActions.js